import React, { useContext } from 'react';
import AgbaContext from '../../context/agba/agbaContext';
import ContactLayout from '../../layoutComponents/contact/ContactLayout';
import { TagDiv } from '../TagPageStyle';

const ContactPage = () => {
  const agbaContext = useContext(AgbaContext);
  const { sideBar } = agbaContext;
  return (
    <TagDiv sideBar={sideBar}>
      <div className='page'>
        <ContactLayout />
      </div>
    </TagDiv>
  );
};

export default ContactPage;
